import { NgClass, NgStyle } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-spinning-loader',
  standalone: true,
  imports: [NgClass, NgStyle],
  templateUrl: './spinning-loader.component.html',
  styleUrl: './spinning-loader.component.scss',
})
export class SpinningLoaderComponent {
  @Input() width = '64';
  @Input() inputClass = 'my-10 text-primary';
}
